module.exports = __WEBPACK_EXTERNAL_MODULE_39__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/core-client/js/core-client/ui/core/Class"
// module id = 39
// module chunks = 0 3